import type { ProductLogoSmallProps } from "../types";

/**
 * 小サイズのCockpitロゴアイコン
 */
export function ProductLogoSmallCockpit({
  size = 20,
  color = "#646467",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6035 10.5C12.1182 10.5 10.1035 12.5147 10.1035 15C10.1035 17.4853 12.1182 19.5 14.6035 19.5C17.0888 19.5 19.1035 17.4853 19.1035 15C19.1035 12.5147 17.0888 10.5 14.6035 10.5ZM16.7559 13.194C16.6257 13.0639 16.4147 13.0639 16.2845 13.194L13.8737 15.6048L12.963 14.694C12.8328 14.5639 12.6218 14.5639 12.4916 14.694L12.2559 14.9297C12.1257 15.0599 12.1257 15.271 12.2559 15.4011L13.638 16.7833C13.7682 16.9135 13.9793 16.9135 14.1094 16.7833L16.9916 13.9011C17.1218 13.771 17.1218 13.5599 16.9916 13.4297L16.7559 13.194Z"
        fill={color}
      />
      <path
        d="M16.1035 2.5C16.3797 2.5 16.6035 2.72386 16.6035 3V4C16.6035 4.27614 16.3797 4.5 16.1035 4.5L6.10352 4.5C5.82737 4.5 5.60352 4.27614 5.60352 4L5.60352 3C5.60352 2.72386 5.82737 2.5 6.10352 2.5L16.1035 2.5Z"
        fill={color}
      />
      <path
        d="M16.1035 7.5C16.3797 7.5 16.6035 7.72386 16.6035 8V9C16.6035 9.27614 16.3797 9.5 16.1035 9.5H6.10352C5.82737 9.5 5.60352 9.27614 5.60352 9L5.60352 8C5.60352 7.72386 5.82737 7.5 6.10352 7.5L16.1035 7.5Z"
        fill={color}
      />
      <path
        d="M8.93685 12.5C9.21299 12.5 9.43685 12.7239 9.43685 13V14C9.43685 14.2761 9.21299 14.5 8.93685 14.5H6.10352C5.82737 14.5 5.60352 14.2761 5.60352 14L5.60352 13C5.60352 12.7239 5.82737 12.5 6.10352 12.5H8.93685Z"
        fill={color}
      />
      <path
        d="M3.10352 2.5C3.37966 2.5 3.60352 2.72386 3.60352 3V4C3.60352 4.27614 3.37966 4.5 3.10352 4.5H2.10352C1.82737 4.5 1.60352 4.27614 1.60352 4L1.60352 3C1.60352 2.72386 1.82737 2.5 2.10352 2.5L3.10352 2.5Z"
        fill={color}
      />
      <path
        d="M3.10352 7.5C3.37966 7.5 3.60352 7.72386 3.60352 8V9C3.60352 9.27614 3.37966 9.5 3.10352 9.5H2.10352C1.82737 9.5 1.60352 9.27614 1.60352 9L1.60352 8C1.60352 7.72386 1.82737 7.5 2.10352 7.5H3.10352Z"
        fill={color}
      />
      <path
        d="M3.10352 12.5C3.37966 12.5 3.60352 12.7239 3.60352 13V14C3.60352 14.2761 3.37966 14.5 3.10352 14.5H2.10352C1.82737 14.5 1.60352 14.2761 1.60352 14L1.60352 13C1.60352 12.7239 1.82737 12.5 2.10352 12.5H3.10352Z"
        fill={color}
      />
    </svg>
  );
}
